<div [ngClass]="showTailClass" class="d-flex flex-column" style="height: 100%">
	<div class="sku__card--title">{{ sku.name }}</div>

	<div class="sku__card--body">
		<div class="sku__description">{{ sku.description }}</div>

		<div class="sku__features">
			<span
				*ngIf="sku.features_available?.length !== 0 || sku.features_unavailable?.length !== 0"
				[ngStyle]="{ color: sku.features_available?.length === 0 && sku.features_unavailable?.length === 0 ? 'grey' : 'black'}"
			>
				Features
			</span>

			<ul class="sku__features__list">
				<li *ngFor="let feature of sku.features_available">
					<mat-icon>check</mat-icon>
					<span> {{ feature.name }}</span>
				</li>

				<li *ngFor="let feature of sku.features_unavailable">
					<mat-icon>close</mat-icon>
					<span> {{ feature.name }}</span>
				</li>
			</ul>
		</div>
	</div>

	<div class="sku__card--footer align-self-center">
		<ng-content select="[sharedCardAction]"></ng-content>
		<ng-container *ngIf="!actionTrigger">
			<button class="btn btn-primary" (click)="triggerAction($event)">
				Show plans in this Package
			</button>
		</ng-container>
	</div>
</div>
